import React, { useState, useRef, forwardRef } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import EventInfoCard from './EventInfoCard';
import StartNumberSearch from './StartNumberSearch';
import ExtendedSearch from '../extended-search/ExtendedSearch';

const EventOnlineView = forwardRef((props, ref) => {
  const {
    onlineEvent,
    onExpandBestof,
    bestOfAvailable,
    extendedSearchSelectedCategoryId,
    showSearchInstructionsDialog,
    extendedSearchSelectedTab,
    extendedSearchExpand,
    onExtendedSearchTabChange,
    onExtendedSearchExpand,
    hasSmartSearchTab,
    hasCategorySearchTab,
    hasGpsSearchTab,
    hasFaceSearchTab,
    hasExtendedSearch,
    onSearchTrigger
  } = props;

  const [startNumber, setStartNumber] = useState(props.urlSn || '');
  const [secondFactor, setSecondFactor] = useState(props.customerKey ? window.atob(props.customerKey) : '');

  const handleInputChange = (name, value) => {
    switch (name) {
      case "startNumber": setStartNumber(value); break;
      case "secondFactor": setSecondFactor(value); break;
    }
  };

  const handleExtendedSearchHintClosed = () => {
    if (!extendedSearchExpand) {
      onExtendedSearchExpand()
    }
  };

  return (
    <div ref={ref}>
      <div className="row">
        <EventInfoCard
          eventInfo={onlineEvent}
          onExpandBestof={onExpandBestof}
          bestOfAvailable={bestOfAvailable}
          eventBannerActAsLink={true}
        />
        <StartNumberSearch
          info={onlineEvent}
          onInputChange={handleInputChange}
          onSearchTrigger={onSearchTrigger}
          onExtendedSearchHintClosed={handleExtendedSearchHintClosed}
          startNumber={startNumber}
          secondFactor={secondFactor}
          showSearchInstructionsDialog={showSearchInstructionsDialog}
        />
      </div>
      {/**
       * If `hasExtendedSearch` is true the extended search options will only be displayed
       */}
      {hasExtendedSearch && (
        <ExtendedSearch
          startnumber={startNumber}
          event={onlineEvent}
          selectedCategoryId={extendedSearchSelectedCategoryId}
          selectedTab={extendedSearchSelectedTab}
          expand={extendedSearchExpand}
          onTabChange={onExtendedSearchTabChange}
          onExpand={onExtendedSearchExpand}
          hasSmartSearchTab={hasSmartSearchTab}
          hasCategorySearchTab={hasCategorySearchTab}
          hasGpsSearchTab={hasGpsSearchTab}
          hasFaceSearchTab={hasFaceSearchTab}
        />
      )}
    </div>
  );
});

EventOnlineView.defaultProps = {
  hasExtendedSearch: true,
};

EventOnlineView.propTypes = {
  extendedSearchSelectedCategoryId: PropTypes.string,
  urlSn: PropTypes.string,
  customerKey: PropTypes.string,
  bestOfAvailable: PropTypes.bool,
  extendedSearchExpand: PropTypes.bool,
  hasSmartSearchTab: PropTypes.bool,
  hasCategorySearchTab: PropTypes.bool,
  hasGpsSearchTab: PropTypes.bool,
  hasFaceSearchTab: PropTypes.bool,
  hasExtendedSearch: PropTypes.bool,
  showSearchInstructionsDialog: PropTypes.bool,
  extendedSearchSelectedTab: PropTypes.number,
  onlineEvent: PropTypes.object,
  onExpandBestof: PropTypes.func,
  onExtendedSearchTabChange: PropTypes.func,
  onExtendedSearchExpand: PropTypes.func,
  onSearchTrigger: PropTypes.func,
};

export { EventOnlineView };

export default createFragmentContainer(EventOnlineView, {
  onlineEvent: graphql`
    fragment EventOnlineView_onlineEvent on Event {
      id
      sgId
      hostResultUrl
      name
      ...EventInfoCard_eventInfo
      ...StartNumberSearch_info
      ...ExtendedSearch_event
    }
  `,
});
